import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../../app/api/routes';
import { COMMUNITY_MEMBERS_RESOURCE, CREATE_COMMUNITY_MEMBER_RESOURCE } from '../constants';
import { JOIN_REQUESTS_RESOURCE } from '../../../../mgmt/communities/constants';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_COMMUNITY_MEMBER_RESOURCE,
      method: 'post',
      request: (communityId, body, callback, rejectCalback, t, templateId) => ({
        url: apiRoutes.communityMembersV2(communityId),
        body,
        meta: {
          callback,
          rejectCalback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'communityMemberCreatedAndInvitedError'),
            onSuccessMessage: t('communityMemberCreatedAndInvited'),
          },
          addToOtherList: {
            resource: COMMUNITY_MEMBERS_RESOURCE,
          },
          removeFromOtherList: templateId
            ? {
                resource: JOIN_REQUESTS_RESOURCE,
                idProp: 'id',
                id: templateId,
              }
            : undefined,
        },
      }),
    },
  ])(ComposedComponent);
